import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        id: ''
    },

    actions: {

    },

    mutations: {
        'activeChatModel/setActiveChat'(state, id){
            state.id = id;
        }
    }

}


// WEBPACK FOOTER //
// ./src/ChatRoom/ActiveChatModel.js